import { AuthApiKeyQuery } from 'dashboard-services/api/auth';

import { useMutation, useQuery } from '@tanstack/react-query';

export default (() => {

  const useCreateApiKey = ({ getQueryBuilder, label, ...rest }) =>
    useMutation({
      ...AuthApiKeyQuery.QUERIES.createKey(
        getQueryBuilder,
        { label }
      ),
      ...rest
    })

  const useDeleteApiKey = ({ getQueryBuilder, id, ...rest }) =>
    useMutation({
      ...AuthApiKeyQuery.QUERIES.deleteKey(
        getQueryBuilder,
        { id }
      ),
      ...rest
    })

  const useGetCurrentUserApiKeys = ({ getQueryBuilder, ...rest }) =>
    useQuery({
      ...AuthApiKeyQuery.QUERIES.getCurrentUserKeys(
        getQueryBuilder
      ),
      ...rest
    })

  return {
    useCreateApiKey,
    useDeleteApiKey,
    useGetCurrentUserApiKeys
  }
})()